import React from 'react'

const UpcomingSessions = () => {
  return (
    <div>UpcomingSessions</div>
  )
}

export default UpcomingSessions